import { render, staticRenderFns } from "./ImageNText.vue?vue&type=template&id=734385d9&scoped=true&"
import script from "./ImageNText.vue?vue&type=script&lang=js&"
export * from "./ImageNText.vue?vue&type=script&lang=js&"
import style0 from "./ImageNText.vue?vue&type=style&index=0&id=734385d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734385d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
